// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

export const SUPABASE_URL = "https://ixbydyiuacoueipvwmep.supabase.co";
export const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml4YnlkeWl1YWNvdWVpcHZ3bWVwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM0MTcwMjcsImV4cCI6MjA4ODk5MzAyN30.iXt4rEKoWmz8xvsayR6hTMczOpXqHHfBMYz86GjRrwE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});